import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Form, Header, Popup } from 'semantic-ui-react';
import { Controller, useForm } from 'react-hook-form';
import { Button, CloseableContent, Notification, RecordsTable, STATUS_TYPES, Table } from 'dyl-components';
import pbxConfigActions from 'actions/pbx_config';

const PhoneSystem = ({ domain, isLoading, onPause, pbxConfigPbxServers, refresh }) => {
    const { control, handleSubmit, reset, formState: { isDirty, isValid } } = useForm({
        defaultValues: {
            pbx_server: ""
        }
    });
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    useEffect(() => {
        if (pbxConfigPbxServers?.length > 0) {
            reset({
                pbx_server: pbxConfigPbxServers?.find((pbx) => pbx?.hostname === domain?.pbx_domain)?.pbx || ""
            });
        }
    }, [pbxConfigPbxServers, reset, domain]);
    const dispatch = useDispatch();
    const params = useParams();
    const onSubmit = async (data) => {
        try {
            await dispatch(pbxConfigActions.updatePbx(params.account_id, { pbx: data.pbx_server }));
            Notification.alert("Successfully updated PBX", STATUS_TYPES.SUCCESS);
            reset();
            if (refresh) {
                refresh();
            }
            setIsPopupOpen(false);
        } catch (e) {
            console.error(e);
            Notification.alert("Failed to update PBX", STATUS_TYPES.ERROR);
        }
    };
    return (
        <RecordsTable
            isTableLoading={isLoading}
            isTableEmpty={false}
            hasPagination={false}
            TableHeader={
                <Table.Row>
                    <Table.HeaderCell>PBX</Table.HeaderCell>
                    <Table.HeaderCell></Table.HeaderCell>
                </Table.Row>
            }
            TableRows={
                <Table.Row>
                    <Table.Cell textAlign='left'>
                        {domain?.pbx}
                    </Table.Cell>
                    <Table.Cell textAlign='right'>
                        <Button size="tiny" onClick={onPause} type="button">{domain?.outbound_paused ? "Unpause" : "Pause"}</Button>
                        <Popup
                            trigger={<Button size="tiny" type="button" onClick={() => setIsPopupOpen(true)}>Update</Button>}
                            position="bottom left"
                            on={['click']}
                            hideOnScroll
                            open={isPopupOpen}
                            onClose={() => {
                                setIsPopupOpen(false);
                            }}
                            wide='very'
                            size='large'
                            content={
                                <>
                                    <Header as='h4' textAlign='left' color='primary'>
                                        Update PBX
                                    </Header>
                                    <CloseableContent onClose={() => {
                                        setIsPopupOpen(false);
                                    }}>
                                        <Form style={{ width: '20em' }} onSubmit={handleSubmit(onSubmit)}>
                                            <Controller
                                                control={control}
                                                name='pbx_server'
                                                render={({ field: { name, value, onChange } }) => (
                                                    <Form.Select
                                                        label='PBX Server'
                                                        name={name}
                                                        value={value}
                                                        onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                                                        placeholder='Select PBX Server'
                                                        required
                                                        options={pbxConfigPbxServers?.map(pbx => ({
                                                            key: pbx.pbx,
                                                            text: pbx.hostname,
                                                            value: pbx.pbx
                                                        }))}
                                                    />
                                                )}
                                            />
                                            <Button
                                                primary
                                                disabled={!isDirty && isValid}
                                                style={{ float: 'right' }}
                                            >
                                                Save
                                            </Button>
                                        </Form>
                                    </CloseableContent>
                                </>
                            }
                        />
                    </Table.Cell>
                </Table.Row>
            }
            recordsName='Phone System'
            noBorder
            emptySubtitleHidden
        />
    );
};

export default PhoneSystem;
